import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_5: FaireProductEntity = {
  token: "toysmith-5",
  type: "product",
  name: "Beetle & Bee Solitary Bee Habitat",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/783b12e8dcbcc7ecaa694789465d979ddef0f6a9dbc8f81e2aeda8da48dd738d.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=943,942,x0,y0,safe&width=720",
  priceDollars: 14,
  msrpDollars: 28,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
